/* eslint-disable */
/**
 * Remove os acentos e characteres especiais de uma string
 * @param {*} data String que vai ser normalizada
 * @returns string normalizada
 */
export function normalizeString(data){
  if (typeof data !== 'string') {
    return undefined;
  }
  return data.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
}
